import { render, staticRenderFns } from "./upcoming.vue?vue&type=template&id=dd85fe6a&scoped=true"
import script from "./upcoming.vue?vue&type=script&lang=js"
export * from "./upcoming.vue?vue&type=script&lang=js"
import style0 from "./upcoming.vue?vue&type=style&index=0&id=dd85fe6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd85fe6a",
  null
  
)

export default component.exports